import { component } from 'picoapp'

export default component(node => {
    class NewAddress {
        constructor(container) {
            this.container = container
            this.open = container.querySelector('[data-open]')
            this.close = container.querySelector('[data-close]')
            this.newAddress = container.querySelector('[data-new-address]')
            this.editAddresses = container.querySelectorAll('[data-edit-address]')
            this.editAddressForms = container.querySelectorAll('[data-edit-address-form]')

            this.openNewAddress()
            this.closeNewAddress()
            this.editAddressHandler()
        }

        openNewAddress() {
            this.open.addEventListener('click', () => {
                this.newAddress.style.display = `block`
            })
        }

        closeNewAddress() {
            this.close.addEventListener('click', () => {
                this.newAddress.style.display = `none`
            })
        }

        editAddressHandler() {
            this.editAddresses.forEach((btn, i) => {
                btn.addEventListener('click', e => {
                    e.preventDefault()
                    this.editAddressForms[i].style.display = `block`
                })
            })
        }
    }

    const newAddress = new NewAddress(node)
})